<template lang="pug">
  div.user-content
    aside-user-nav
    div.user-view
      router-view
    contact-us
</template>
<script>
import AsideUserNav from './AsideUserNav'
import ContactUs from '../components/ContactUs'
import store from '../store'
export default {
  name: 'UserCenter',
  beforeRouteEnter (to, from, next) {
    if (!store.state.user.userinfo.phone) {
      store.dispatch('GetUserinfo')
        .then(res => {
          next()
        })
    } else {
      next()
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    AsideUserNav,
    ContactUs
  }
}
</script>
<style lang="scss" scoped>
  .user-content{
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    .user-view{
      margin-top: 10px;
      height: calc(100% - 78px);
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/UserCenter/UserCenter.vue